import React from 'react';
import PropTypes from 'prop-types';

import AccessibleIcon from './AccessibleIcon';

const propTypes = {
    label: PropTypes.string,
    className: PropTypes.string
};

const defaultProps = {
    label: 'Information',
    className: ''
};

function InfoIcon(props) {
    return (
        <AccessibleIcon
        className={props.className}
        label={props.label}>
            <span className="fa fa-info-circle" aria-hidden="true"/>
        </AccessibleIcon>
    );
}

InfoIcon.propTypes = propTypes;
InfoIcon.defaultProps = defaultProps;

export default InfoIcon;